import React from 'react';

export const formatNumberPrecise = (num) => {
  if (typeof num !== 'number' || isNaN(num)) return '0';
  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';
  const thresholds = [
    { value: 1_000_000, suffix: 'M' },
    { value: 1_000, suffix: 'k' },
  ];
  for (const { value, suffix } of thresholds) {
    if (absNum >= value) {
      const scaledNum = absNum / value;
      return `${sign}${scaledNum.toFixed(1).replace(/\.0$/, '')}${suffix}`;
    }
  }
  return `${sign}${absNum}`;
};

const StatCard = ({ icon, title, value, color, usePreciseFormat = false, isLoading }) => {
  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderTop: `3px solid ${color}`,
        borderRadius: 14,
        padding: '22px 20px',
        textAlign: 'center',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'default',
        boxShadow: `0 4px 20px rgba(0,0,0,0.2)`
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = `0 12px 32px rgba(0,0,0,0.35), 0 0 0 1px ${color}33`;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.2)';
      }}
    >
      {/* Icon */}
      <div style={{
        width: 52, height: 52, borderRadius: '12px',
        background: `${color}20`,
        border: `1px solid ${color}40`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 16px',
        fontSize: 20, color: color
      }}>
        <i className={icon} />
      </div>

      {isLoading ? (
        <div>
          <div style={{
            height: 34, width: '55%',
            background: 'rgba(255,255,255,0.08)',
            borderRadius: 8, margin: '0 auto 10px',
            animation: 'pulse 1.5s ease infinite'
          }} />
          <div style={{
            height: 12, width: '75%',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: 6, margin: '0 auto'
          }} />
        </div>
      ) : (
        <div>
          <div style={{
            fontSize: 32, fontWeight: 800, color: '#fff',
            lineHeight: 1.2, marginBottom: 6
          }}>
            {usePreciseFormat ? formatNumberPrecise(value) : Number(value).toFixed(2)}
          </div>
          <div style={{
            fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)',
            textTransform: 'uppercase', letterSpacing: '0.06em'
          }}>
            {title}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatCard;
